import React from 'react';
import ReactDOM from 'react-dom/client';


//import "Styles/scss/mainstyle.scss";
import "Styles/scss/current/app.scss";
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux'
//import 'Styles/stylevariables.css';
import 'Styles/psoppcStyles.css';
//import 'Styles/stylesheets/index.css';

import {store, persistor} from './Store/index';
import { PersistGate } from 'redux-persist/integration/react'
import TagManager from 'react-gtm-module';
import { config } from 'Utils/config';
import {getIds} from 'Utils/GA4/GTM';
import { loadRecaptchaScriptOnce } from './Components/ReCaptcha/loadRecaptchaScriptOnce';

const d = getIds();

const tagManagerArgs = {
    gtmId: d[0]
    
};
TagManager.initialize(tagManagerArgs);

// Load ReCaptcha script on app startup
if (config.recaptchaV3DevSiteKey) {
  loadRecaptchaScriptOnce(`https://www.google.com/recaptcha/api.js?render=${encodeURIComponent(config.recaptchaV3DevSiteKey)}`)
    .then(() => {
      console.log('ReCaptcha script loaded successfully');
    })
    .catch((error) => {
      console.error('Failed to load ReCaptcha script:', error);
    });
}





const root = ReactDOM.createRoot(document.getElementById('root'));


root.render(
    <Provider store={store} >
        <PersistGate persistor={persistor}>
            <BrowserRouter>
                
                    <App/>
                
            </BrowserRouter>
        </PersistGate>
    </Provider>
);
 
